const shortenText = (text: string, maxLength = 24) => {
  if (text) return text.length > maxLength ? text.slice(0, maxLength) + '...' : text
  return null
}

export default shortenText
